import { Injectable } from '@angular/core';
import { environment } from '../../../env/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TraitementService {

 host_Traitement = `${environment.API_URI}/api/traitement`;

  constructor(private http: HttpClient) { }

  private getAuthHeaders(): HttpHeaders {
    const purecloud_auth_data = localStorage.getItem('purecloud_auth_data');
    const token = purecloud_auth_data ? JSON.parse(purecloud_auth_data).accessToken : null;

    if (!token) throw new Error("Missing access token");

    return new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
  }

  getTraitementsByDo(code_DO: number) {
    const url = `${this.host_Traitement}/all/${code_DO}`;
    return this.http.get(url, { headers: this.getAuthHeaders() });
  }

exportTraitementsByDo(code_Do: number): Observable<Blob> {
    const url = `${this.host_Traitement}/export/${code_Do}`;
    return this.http.post<Blob>(url, null, {
      headers: this.getAuthHeaders(),
      responseType: 'blob' as 'json'
    });
  }
}
